import { GET_ACCOUNT_DETAIL,EDIT_CARD_DETAILS } from '../Actions/actionTypes';

let initial={
    TransactionDates:[]
};

export default (state=initial,action)=>{
    switch(action.type){
        case GET_ACCOUNT_DETAIL :
            if(action.payload.ResponseCode)
                return action.payload;
            else
                return state;
      case EDIT_CARD_DETAILS :
        if(action.payload.ResponseCode)
          return action.payload;
        else
          return state;
        default:
            return state;
    }
}